const cookieOptions = {
  DEC_AIDED_SELLING: 'DEC_AIDED_SELLING',
};

export function setCookie(name: keyof typeof cookieOptions, value: string, days = 2) {
  if (typeof document === 'undefined') return;

  const expires = new Date(Date.now() + days * 864e5).toUTCString();

  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
}

export function getCookie(name: keyof typeof cookieOptions): string | undefined {
  if (typeof document === 'undefined') return undefined;

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) return parts.pop()?.split(';').shift();

  return undefined;
}

export function deleteCookie(name: keyof typeof cookieOptions) {
  if (typeof document === 'undefined') return;

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
}
